'use strict';

angular.module('shiftTraderApp')
  .directive('saHeaderDatePicker', ['$rootScope', 'Session', 'TimeService', '$location', function ($rootScope, Session, TimeService, $location) {
    return {
      templateUrl: 'views/directives/saHeaderDatePicker.html',
      restrict: 'EA',
      link: function(scope, element) {
        scope.currentPickerDate = {date: null};

        scope.$on('$locationChangeSuccess', function () {
          if(/^\/manageWorkPeriods/.test($location.path())) {
            scope.renderElement = true;
          } else {
            scope.renderElement = false;
          }
        });

        if(/^\/manageWorkPeriods/.test($location.path())) {
          scope.renderElement = true;
        }

        var datepickerWatchDereg = null;
        scope.$on('sa:updatedOrgData', function(event, data) {
          scope.org = data;
          scope.startOfWeekDay = Session.getStartOfWeekDay();
        });

        scope.$on('sa:manageWorkPeriod:dateChangeRequest', function(event, obj) {
          //window.logTime((event.name);
          console.log('sa:manageWorkPeriod:dateChangeRequest', obj, obj.moment && obj.moment.format(), obj.delta && (obj.delta.numIntervals + ' ' + obj.delta.interval));

          if (obj.moment) {
            changeCurrentMWPDate(obj.moment);
          } else if (obj.delta) {

            var temp = moment(scope.currentDate).add(obj.delta.interval, obj.delta.numIntervals);
            changeCurrentMWPDate(temp);
          }

          if (_.isNull(datepickerWatchDereg)) {
            setupDatepickerWatch();
          }
        });

        var setupDatepickerWatch = function() {
          datepickerWatchDereg = scope.$watch('currentPickerDate.date', function(newDt, oldDt) {
            //console.log('currentPickerDate.date $watch', newDt, oldDt, newDt === oldDt, ignoreWatch);
            if (newDt !== oldDt && !ignoreWatch) {
              //console.log('executed changeCurrentMWPDate()');
              changeCurrentMWPDate();
            }
            ignoreWatch = false;
          });
        };

        var ignoreWatch = false;
        var changeCurrentMWPDate = function(optDate) {
          //window.logTime(('changeCurrentMWPDate');
          if (optDate) {
            scope.currentDate = TimeService.getBeginningOfDayFromDate(optDate);
            ignoreWatch = true;
            scope.currentPickerDate.date = TimeService.momentToDateInLocalOffset(scope.currentDate);
            console.log('currentPickerDate.date', scope.currentPickerDate.date);
          } else {
            scope.currentDate = TimeService.getBeginningOfDayFromDate(scope.currentPickerDate.date);
            //console.log('currentDate in changeCurrentMWPDate: ', scope.currentDate.format());
          }

          Session.setCurrentCalendarDate(scope.currentDate.format('YYYY-MM-DD'));
          $location.path('manageWorkPeriods/' + moment(scope.currentDate).format('YYYY-MM-DD'));
          //console.log('$broadcast: sa:manageWorkPeriod:dateChange', scope.currentDate.format());
          $rootScope.$broadcast('sa:manageWorkPeriod:dateChange', scope.currentDate);
        };

        scope.currentDate = null;

        scope.datePickerOptions = {
          startingDay: scope.startOfWeekDay,
          showWeeks: false
        };

        scope.datepickers = {
          primary: false
        };

        scope.openDatepicker = function($event) {
          console.log($event);
          $event.preventDefault();
          $event.stopPropagation();

          if (scope.datepickers.primary === true) {
            scope.datepickers.primary = false;
          } else {
            scope.datepickers.primary = true;
          }
          console.log(scope.datepickers.primary);
        };

        scope.addOneDay = function() {
          var plusOneDate = moment(scope.currentDate).add(24, 'hours');
          var currDSTEval1 = moment(scope.currentDate).add({'hours':1});
          var plusOneDSTEval1 = moment(plusOneDate).add(1, 'hours');


          if (!currDSTEval1.isDST() && plusOneDSTEval1.isDST()) {
            //moving into daylight savings time; March 9th -> March 10th
            scope.currentDate = plusOneDate.subtract(1, 'hours');
          } else if ( (currDSTEval1.isDST() && !plusOneDSTEval1.isDST()) ) {
            //coming out of daylight savings time; Nov 2nd -> Nov 3rd
            scope.currentDate = plusOneDate.add(1, 'hours');
          } else {
            scope.currentDate = plusOneDate;
          }
          //$state.go('manageWorkPeriods.date', {date: scope.currentDate.format('YYYY-MM-DD')});

          //scope.currentPickerDate.date = moment(scope.currentDate).toDate();
          scope.currentPickerDate.date = TimeService.momentToDateInLocalOffset(scope.currentDate);
          scope.scrollTheWindow = true;
        };

        scope.subtractOneDay = function() {
          var minusOneDate = moment(scope.currentDate).subtract(24, 'hours');
          var currDSTEval1 = moment(scope.currentDate).add({'hours':0});
          var minusOneDSTEval1 = moment(minusOneDate).add({'hours':0});

          if (!currDSTEval1.isDST() && minusOneDSTEval1.isDST()) {
            //moving into daylight savings time; Nov 3 -> Nov 2
            scope.currentDate = minusOneDate.subtract(1, 'hours');
          } else if(currDSTEval1.isDST() && !minusOneDSTEval1.isDST()) {
            //coming out of daylight savings time; March 10th -> March 9th
            scope.currentDate = minusOneDate.add(1, 'hours');
          } else {
            scope.currentDate = minusOneDate;
          }
          scope.currentPickerDate.date = TimeService.momentToDateInLocalOffset(scope.currentDate);
          scope.scrollTheWindow = true;

        };

      }
    };
  }]);
